export const convertFeeInMinUnitToMainUnit = (feeInMinUnit: number): number => feeInMinUnit / 100;
export const convertFeeInMainUnitToMinUnit = (feeInMainUnit: number): number => feeInMainUnit * 100;

export const convertFeeInMinUnitToMainUnitFixed = (feeInMinUnit: number): string =>
  convertFeeInMinUnitToMainUnit(feeInMinUnit).toFixed(2);
